export interface ArticleCard {
  id: string
  title: string
  excerpt: string
  authorName: string
  publishedAt: string
  coverImageUrl: string | null
}

export interface AcademyReply {
  id: string
  content: string
  authorName: string
  authorId: number
  createdAt: string
  edited: boolean
  removed: boolean
  canEdit: boolean
  canRemove: boolean
}

export const formatAcademyDate = (value: string) =>
  new Intl.DateTimeFormat('pt-BR', { dateStyle: 'medium' }).format(new Date(value))
